import { useState, useEffect, useMemo } from "react";

import PopupSectionTitle from "../components/PopupSectionTitle";
import InputDataCurrency from "./InputDataCurrency";

import ButtonIconH from "../../components/ButtonIconH";

import DataTable from "react-data-table-component";
import moment from "moment";

import { formatCurrency, formatFloatFromCurrency } from "../utils/utils";
import { post } from "../../js/post";

import { userData } from "../../js/utils";

import "../css/CashVoucherPopup.css";

export default ({
  show,
  patientId,
  onClose,
  onChangeNumCashVouchers,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [cashVouchersTable, setCashVouchersTable] = useState([]);
  const [newCashVoucher, setNewCashVoucher] = useState(null);

  const cashVouchersColumns = useMemo(
    () => [
      {
        name: "Fecha de emisión",
        selector: (row) =>
          moment(row.creationDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        sortable: true,
        width: "25%",
        sortFunction: (a, b) => {
          return (
            moment(a.creationDate, "YYYY-MM-DD") -
            moment(b.creationDate, "YYYY-MM-DD")
          );
        },
      },
      {
        name: "Importe",
        selector: (row) => formatCurrency(row.amount),
        sortable: true,
        width: "24%",
        right: true,
        sortFunction: (a, b) => {
          return a.amount - b.amount;
        },
      },
      {
        name: "Canjeado",
        cell: (row) =>
          row.reedemedDate !== "" ? (
            <img
              src="/images/support-extra/controlar.svg"
              title="Validado"
              className="icon-pref"
              alt="Validado"
            />
          ) : null,
        sortable: true,
        width: "23%",
        sortFunction: (a, b) => {
          const A = a.reedemedDate ? 1 : 0;
          const B = b.reedemedDate ? 1 : 0;
          return A - B;
        },
      },
      {
        name: "Fecha de canje",
        selector: (row) =>
          row.reedemedDate === ""
            ? ""
            : moment(row.reedemedDate, "YYYY-MM-DD").format("DD/MM/YYYY"),
        sortable: true,
        width: "25%",
        sortFunction: (a, b) => {
          const aDate = a.reedemedDate || "";
          const bDate = b.reedemedDate || "";

          if (!aDate && !bDate) return 0;
          if (!aDate) return 1;
          if (!bDate) return -1;

          return (
            moment(a.reedemedDate, "YYYY-MM-DD") -
            moment(b.reedemedDate, "YYYY-MM-DD")
          );
        },
      },
      {
        name: "",
        width: "3%",
        cell: (row) => (
          <div className="navtable-opt ntc-trash cash-voucher-popup">
            <img
              src="/images/remove-blue.svg"
              onClick={() => deleteCashVoucher(row.id)}
            />
          </div>
        ),
      },
    ],
    [cashVouchersTable],
  );

  const openNewCashVoucher = (show) => {
    const newCashVoucherN = show
      ? {
          amount: 0,
        }
      : null;
    setNewCashVoucher(newCashVoucherN);
  };

  const loadCashVouchers = async () => {
    const response = await post("support/ValesCaja/ListarValesCaja.php", {
      token: userData.token,
      idCliente: patientId,
    });

    const cashVouchersTableN = response.map((cv) => ({
      id: cv.id,
      creationDate: cv.fecha_emision,
      amount: parseFloat(cv.importe),
      reedemedDate: cv.fecha_canjeado,
    }));

    setCashVouchersTable(cashVouchersTableN);
  };

  const createCashVoucher = async (newVoucherN) => {
    if (newVoucherN.amount === "" || newVoucherN.amount <= 0) {
      createPopupQuestion(
        "El importe del vale de caja no es válido.",
        () => removePopupQuestion(),
        null,
        "Cerrar",
      );
      return;
    }

    const response = await post("support/ValesCaja/InsertarValeCaja.php", {
      token: userData.token,
      idCliente: patientId,
      importe: newVoucherN.amount,
    });

    const cashVoucher = {
      id: response.idValeCaja,
      creationDate: moment().format("YYYY-MM-DD"),
      amount: newVoucherN.amount,
      reedemedDate: "",
    };

    const cashVouchersTableN = structuredClone(cashVouchersTable);
    cashVouchersTableN.push(cashVoucher);
    setCashVouchersTable(cashVouchersTableN);
    setNewCashVoucher(null);

    onChangeNumCashVouchers(cashVouchersTableN.length);
  };

  const onChangeCashVoucherAmount = (value, save) => {
    const newCashVoucherN = structuredClone(newCashVoucher);
    newCashVoucherN.amount = formatFloatFromCurrency(value);
    if (save) {
      createCashVoucher(newCashVoucherN);
    } else {
      setNewCashVoucher(newCashVoucherN);
    }
  };

  const deleteCashVoucher = (id) => {
    createPopupQuestion(
      "¿Deseas eliminar el vale de caja?",
      () => {
        const cashVouchersTableN = cashVouchersTable.filter(
          (cv) => cv.id !== id,
        );
        setCashVouchersTable(cashVouchersTableN);
        removePopupQuestion();

        post("support/ValesCaja/EliminarValeCaja.php", {
          token: userData.token,
          idValeCaja: id,
        });

        onChangeNumCashVouchers(cashVouchersTableN.length);
      },
      removePopupQuestion,
      "Eliminar",
      "Cancelar",
    );
  };

  useEffect(() => {
    if (show === true) {
      setNewCashVoucher(null);
      loadCashVouchers();
    }
  }, [show]);

  return (
    show && (
      <div className="popup-container popup-normal popup-cash popup-cashvoucher">
        <div className="popup-message">
          <div className="popup-header">
            <div className="popup-title">Vales de caja</div>
            <img
              src="/images/close-white.svg"
              loading="lazy"
              alt=""
              className="popup-close"
              onClick={() => onClose()}
            />
          </div>
          <div className="popup-body">
            <div className="popup-row table-scrollable">
              <DataTable
                columns={cashVouchersColumns}
                data={cashVouchersTable}
                className="custom-datatable non-interactive"
                noDataComponent="No hay datos disponibles."
              />
            </div>
            {newCashVoucher != null && (
              <PopupSectionTitle title="Nuevo vale de caja" />
            )}
            {newCashVoucher != null && (
              <div className="popup-row">
                <div className="label">Cantidad</div>
                <InputDataCurrency
                  id="p-cashvoucher-amount"
                  tabIndex={1001}
                  type="type-float"
                  size={1}
                  input={newCashVoucher.amount.toString()}
                  onChange={(e) => {}}
                  onBlur={(e) => onChangeCashVoucherAmount(e, false)}
                  inactive={false}
                  onEnter={(e) => onChangeCashVoucherAmount(e, true)}
                />
              </div>
            )}
          </div>
          {newCashVoucher == null && (
            <div className="popup-cashvoucher-footer">
              <ButtonIconH
                text="Nuevo vale de caja"
                onClick={() => openNewCashVoucher(true)}
              />
            </div>
          )}
          {newCashVoucher != null && (
            <div className="popup-cashvoucher-footer">
              <ButtonIconH
                text="Guardar"
                onClick={() => createCashVoucher(newCashVoucher)}
              />
              <ButtonIconH
                text="Cancelar"
                onClick={() => openNewCashVoucher(false)}
              />
            </div>
          )}
        </div>
      </div>
    )
  );
};

/*

const cashVouchersOr = [
  {
    id: 1,
    creationDate: "2025-03-01",
    amount: 30,
    reedemedDate: "",
  },
  {
    id: 2,
    creationDate: "2025-04-22",
    amount: 2,
    reedemedDate: "2025-04-30",
  },
  {
    id: 3,
    creationDate: "2025-05-15",
    amount: 1000,
    reedemedDate: "",
  },
  {
    id: 4,
    creationDate: "2025-06-01",
    amount: 100,
    reedemedDate: "2025-07-17",
  },
];

*/
